import { render, staticRenderFns } from "./ProductCardTable.vue?vue&type=template&id=5eaff618"
import script from "./ProductCardTable.vue?vue&type=script&lang=js"
export * from "./ProductCardTable.vue?vue&type=script&lang=js"
import style0 from "./ProductCardTable.vue?vue&type=style&index=0&id=5eaff618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports